'use strcit';

const React = require('react');
const PropTypes = require('prop-types');
const MediaQuery = require('../../global/components/MediaQuery');
const HomepageCarousel = require('./HomepageCarousel');
const HeroItem = require('./HeroItem');
const Personalization = require('./personalization');
const CollectionsItem = require('./CollectionsItem');
const {queries} = require('../../global/core/commonjs/screenSize.es');
const tracking = require('../helpers/tracking');

function Hero(props) {
    const carouselProps = {
        auto: true,
        useDotsNav: true,
        onImpression: tracking.trackHeroImpression
    };
    return (
        <HomepageCarousel {...carouselProps} {...props} >
            <HeroItem onClick={tracking.trackHeroClick} />
        </HomepageCarousel>
    );
}

function Collections(props) {
    const carouselProps = {
        transitionEffect: 'slide',
        onPageChange: tracking.trackCollectionsArrows,
        onImpression: tracking.trackCollectionsImpression,
        classNames: {
            list: 'collections-carousel-list',
            item: 'collections-carousel-item'
        }
    };
    return (
        <HomepageCarousel {...carouselProps} {...props} >
            <CollectionsItem onClick={tracking.trackCollectionsClick} />
        </HomepageCarousel>
    );
}

function ResponsiveCollection(props) {
    return (
        <div>
            <MediaQuery query={[queries.lg, queries.xl]}>
                <Collections itemsPerPage={5} {...props} />
            </MediaQuery>

            <MediaQuery query={queries.md}>
                <Collections itemsPerPage={4} {...props} />
            </MediaQuery>

            <MediaQuery query={[queries.xs, queries.sm]}>
                <Collections itemsPerPage={3.5} isMobile {...props} />
            </MediaQuery>
        </div>
    );
}

ResponsiveCollection.propTypes = {
    items: PropTypes.array.isRequired
};

function ResponsiveHero(props) {
    return (
        <div>
            <MediaQuery query={[queries.xl]}>
                <Hero itemsPerPage={4} {...props} />
            </MediaQuery>

            <MediaQuery query={[queries.lg]}>
                {/* Weird slice, right? We drop the last item because we want make sure all of the carousel pages are full */}
                <Hero itemsPerPage={3} {...props} items={props.items.slice(0, -1)} />
            </MediaQuery>

            <MediaQuery query={[queries.md]}>
                <Hero itemsPerPage={2} {...props} />
            </MediaQuery>

            <MediaQuery query={[queries.xs, queries.sm]}>
                <Hero itemsPerPage={1.5} {...props} useDotsNav={false} isMobile />
            </MediaQuery>
        </div>
    );
}

ResponsiveHero.propTypes = {
    items: PropTypes.array.isRequired
};


module.exports = {
    ResponsiveHero,
    ResponsiveCollection,
    Personalization
};



// WEBPACK FOOTER //
// ./assets/js/home/components/carousels.jsx